var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "custom-table" },
    [
      _c(
        "vxe-table",
        {
          ref: "xTable",
          attrs: { border: "", "show-overflow": "", data: _vm.orderData },
        },
        [
          _c("vxe-table-column", {
            attrs: { field: "productCode", align: "center", title: "产品编码" },
          }),
          _c("vxe-table-column", {
            attrs: {
              field: "productLevelName",
              align: "center",
              title: "产品系列名称",
            },
          }),
          _c("vxe-table-column", {
            attrs: { field: "productName", align: "center", title: "产品名称" },
          }),
          _c("vxe-table-column", {
            attrs: {
              field: "productPrice",
              align: "center",
              title: "直营产品单价(瓶/盒)元",
            },
          }),
          _c("vxe-table-column", {
            attrs: {
              field: "productNum",
              align: "center",
              title: "数量（瓶/盒）",
            },
          }),
          _c("vxe-table-column", {
            attrs: {
              field: "productTotalAmount",
              align: "center",
              title: "总金额",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }